import React from 'react'
import { formBuilderParams } from "../FormBuilder"
import { Link, Stack, Typography } from "@mui/material"
import { Controller } from "react-hook-form"

/**
 * @typedef {import("../lib/FormBuilderFieldBuilder").baseFormComponentProps} baseFormComponentProps
 * @typedef {import("../lib/FormBuilderFieldBuilder").baseConfig} baseConfig
 * @typedef {import("../lib/FormBuilderFieldBuilder").textDisplayConfig} textDisplayConfig
 * @param {baseFormComponentProps & baseConfig & textDisplayConfig} props
 */
const FormBuilderTextDisplay = ({
  formProps,
  fieldName,
  label,
  hideLabel,
  displayValue,
  onClick,
  href,
  fontVariant = "body1",
  prefix,
  suffix,
}) => {
  const useLink = href || onClick;
  const getLink = (value) => <Link underline="hover" onClick={() => onClick && onClick(value)} href={href} sx={{ cursor: "pointer", verticalAlign: "unset" }}>{value}</Link>

  const getDisplayedValue = (value) => `${prefix ?? ""}${value ?? ""}${suffix ?? ""}`

  if (!displayValue)
    return (
      <Controller
        key={fieldName}
        name={fieldName}
        control={formProps.control}
        render={({ field: { value } }) => (
          <Stack direction="column" sx={{ ...formBuilderParams.formItemStyle, justifyContent: "center" }}>
            <Typography variant={fontVariant}>
              {!hideLabel ? `${label}: ` : ""}
              {
                useLink
                  ? getLink(value)
                  : getDisplayedValue(value)
              }
            </Typography>
          </Stack>
        )} />
    )
  else return (
    <Stack direction="column" sx={{ ...formBuilderParams.formItemStyle, justifyContent: "center" }}>
      <Typography variant={fontVariant}>
        {!hideLabel ? `${label}: ` : ""}
        {
          useLink
            ? getLink(displayValue)
            : getDisplayedValue(displayValue)
        }
      </Typography>
    </Stack>
  )
}

export default FormBuilderTextDisplay;